<template>
    <div class="simple-scale-item">
      <question :text="$t(item.text)" />
      <div v-if="!isSlider">
        <multi-buttons
          :options="options"
          @select="handleSelect"
        />
      </div>

      <div v-if="isSlider">
        <discrete-slider
          :options="options"
          :range="[item.scaleMin, item.scale]"
          @change="handleSelect"
          :labelMin="labelMin"
          :labelMax="labelMax"
        />

      </div>
    </div>
</template>

<script>
import { SORT_ORDER, ITEM_MODE } from '@/constants/items'
import { getLabel } from '@/utils/items'
import itemMixin from '@/components/mixins/itemMixin'
import multiButtons from '@/components/inputs/multiButtons'
import discreteSlider from '@/components/inputs/discreteSlider'

import question from '@/components/ui/question'

const MODE = {
  BUTTON: 'button',
  SLIDER: 'slider'
}

export default {
  name: 'simpleScaleItem',
  mixins: [
    itemMixin
  ],
  components: {
    question,
    'multi-buttons': multiButtons,
    'discrete-slider': discreteSlider,
  },
  props: {
    item: {
      type: Object
    },
    itemProperties: {
      type: Object
    }
  },
  data() {
    return {
      MODE,
    }
  },
  computed: {
    mode() {
      // if we have no labels for items we display it as slider
      return this.itemProperties.getProperty(ITEM_MODE) === MODE.SLIDER ? MODE.SLIDER : MODE.BUTTON 
    },
    isSlider() {
      return this.mode === MODE.SLIDER
    },
    sortDesc() {
      return this.itemProperties.getProperty(SORT_ORDER) === 'desc'
    },
    options() {
      return [...Array(this.item.scale)]
        .map((_, i) => {

          let text = ''
          if(this.isSlider) {
            text = i + 1
          } else {
            text = this.sortDesc ? this.scaleText(this.item.scale - i, this.item.scale) : this.scaleText(i + 1, this.item.scale)
          }

          return {
            value: this.sortDesc ? this.item.scale - i : i + 1,
            text
          }
        })
    },
    labelMin() {
      return this.item.labels.length > 0 ? this.$t(getLabel(this.item, 'SCALE_LABEL_MIN').text) : ''
    },
    labelMax() {
      return this.item.labels.length > 0 ? this.$t(getLabel(this.item, 'SCALE_LABEL_MAX').text) : ''
    }
  },
  methods: {
    handleSelect(option) {
      this.$emit('answer', { 
        result: option.value 
      })
    }
  },
};
</script>
<style lang="scss">
  .simple-scale-item {
    height: 100%;
  }
</style>